import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {

  private menuSource = new BehaviorSubject<any>({ menu:'', subMenu:'' });
  menu$ = this.menuSource.asObservable();

  setMenuName(menu: string, subMenu: string) {
    this.menuSource.next({ menu, subMenu });
  }

}